import { Check } from "lucide-react";

export const ChipGroup = ({ options, value, onChange, multi = false, testId, cols = "grid-cols-2" }) => {
  const selected = multi ? value || [] : [value];
  const toggle = (opt) => {
    if (!multi) return onChange(value === opt ? "" : opt);
    onChange(selected.includes(opt) ? selected.filter((o) => o !== opt) : [...selected, opt]);
  };
  return (
    <div className={`grid ${cols} gap-2`} data-testid={testId}>
      {options.map((opt, i) => {
        const on = selected.includes(opt);
        return (
          <button type="button" key={opt} onClick={() => toggle(opt)} data-testid={`${testId}-option-${i}`}
            className={`min-h-12 px-3 rounded-lg border text-sm font-semibold flex items-center justify-between gap-2 text-start transition-colors ${
              on ? "bg-brand-red border-brand-red text-white" : "bg-panel border-line text-slate-200 hover:border-brand-red/60"
            }`}>
            <span>{opt}</span>
            {on && <Check size={16} />}
          </button>
        );
      })}
    </div>
  );
};
